const CopyIcon = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M5.83325 5.83301V2.66634C5.83325 2.2061 6.20635 1.83301 6.66658 1.83301H13.3333C13.7935 1.83301 14.1666 2.2061 14.1666 2.66634V9.33301C14.1666 9.79324 13.7935 10.1663 13.3333 10.1663H10.1666M9.33325 5.83301H2.66659C2.20635 5.83301 1.83325 6.2061 1.83325 6.66634V13.333C1.83325 13.7932 2.20635 14.1663 2.66659 14.1663H9.33325C9.79349 14.1663 10.1666 13.7932 10.1666 13.333V6.66634C10.1666 6.2061 9.79349 5.83301 9.33325 5.83301Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default CopyIcon
